module.exports = __webpack_public_path__ + "img/bianzu1.0ec3b067.png";